import styled from 'styled-components';

// Types for styled components
type ContainerProps = {
  width: number;
  height: number;
};

type StyledSvgProps = {
  width: number;
  height: number;
};

type PathElementProps = {
  isClickable: boolean;
};

type PositionedElementProps = {
  spacing: number;
};

// Styled Components
export const Container = styled.div<ContainerProps>`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  position: relative;
`;

export const StyledSvg = styled.svg<StyledSvgProps>`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
`;

export const PathElement = styled.path<PathElementProps>`
  cursor: ${(props) => (props.isClickable ? 'pointer' : 'default')};
  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: ${(props) => (props.isClickable ? 0.8 : 1)};
  }
`;

export const PositionedElement = styled.div<PositionedElementProps>`
  position: absolute;
  top: ${(props) => props.spacing}px;
  left: ${(props) => props.spacing}px;
  right: ${(props) => props.spacing}px;
  bottom: ${(props) => props.spacing}px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;
